<template>
    <div>
        <or-page-title>О компании</or-page-title>
        <div class="layout-1200">
            <div class="container padding-top-50 padding-bottom-50">
                <div class="item" v-for="item in options" :key="item">
                    <or-about-text v-if="item.component === 'text'" class="text" :text="item.text"/>
                    <or-about-card v-else class="card" :card="item"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import orPageTitle from '../global/or-page-title.vue'
import orAboutText from './parts/about-page/or-about-text.vue'
import orAboutCard from './parts/about-page/or-about-card.vue'
import Axios from 'axios'
export default {
    components: {orPageTitle, orAboutText, orAboutCard},
    data() {
        return {
            options: [],
        }
    },
    mounted() {
        if (this.getAbout === null) {
            this.changeIsPageReady({is: false});
        }
        const i = setInterval(()=>{
            if (this.getAbout !== null) {
                clearInterval(i);
                this.getFromState()
            }
        }, 10);
    },
    computed: {
        ...mapGetters({getAbout: 'getAbout'}),
    },
    methods: {
        ...mapActions({changeIsPageReady: 'changeIsPageReady', changeAbout: 'changeAbout'}),
        getFromState() {
            this.options = this.getAbout;
            this.changeIsPageReady({is: true})
        },
    },
}
</script>

<style scoped>
    .item {
        margin-bottom: 50px;
    }
    .item:last-of-type {
        margin-bottom: 0;
    }
</style>